import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { FmButton, FmText, FmUnderlineNav } from "../../../../Components";
import useStyles from "./BottomSection.styles";

interface BottomSectionProps {
  onClear?: () => void;
  className?: string;
  canSubmit?: boolean;
  loading?: boolean;
  clearButtonIsDisabled?: boolean;
  onSubmit?: () => void;
  onBackButton?: () => void;
}

const BottomSection = ({ onClear, loading, canSubmit, className, onSubmit, onBackButton, clearButtonIsDisabled }: BottomSectionProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classes.button}>
        <FmButton
          disabled={!canSubmit || loading}
          type={!onSubmit ? "submit" : "button"}
          fullWidth="mobileFullWidth"
          loading={loading}
          onClick={onSubmit}
        >
          {t("general.next")}
        </FmButton>
      </div>

      <div className={classes.textContainer} onClick={onClear}>
        <FmUnderlineNav title={t("general.clearStep")} disabled={clearButtonIsDisabled} />
      </div>

      {onBackButton && (
        <div className={classes.backContainer} onClick={onBackButton}>
          <div>
            <img src={"/multi-match/assets/skip.png"} alt="skip" className={classes.img} />
          </div>
          <div className={classes.title}>{t("back")}</div>
        </div>
      )}
    </div>
  );
};

export default BottomSection;
